import { useCallback } from "react";

import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentClassUserId,
  selectCurrentSectionId,
  selectCurrentSectionUserId,
  selectCurrentUserId,
} from "store/selectors";

export const useJoinAsSectionAdmin = () => {
  const currentSectionUserId = useAppSelector(selectCurrentSectionUserId);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const currentSectionId = useAppSelector(selectCurrentSectionId);
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);

  const joinAsSectionAdminIfNew = useCallback(async () => {
    let sectionUserId = currentSectionUserId;
    let classUserId = currentClassUserId;

    if (!currentSectionUserId) {
      sectionUserId = (
        await storeApi.section_users.create({
          section_id: currentSectionId!,
          user_id: currentUserId!,
          role: "section_admin",
        })
      )?.id;

      classUserId = (
        await storeApi.class_users.create({
          section_id: currentSectionId!,
          section_user_id: sectionUserId,
        })
      )?.id;
    }

    return { sectionUserId: sectionUserId!, classUserId: classUserId! };
  }, [currentSectionUserId, currentSectionId, currentUserId, currentClassUserId]);

  return { joinAsSectionAdminIfNew };
};
